// Cuentas por canal del helpdesk (números/páginas vinculados al operador
// logístico): GET /conversations/channel-accounts de microservice-conversations.
// La comparten el inbox y el resto de vistas de la suite, porque el rail decide
// con ellas qué canales mostrar.
import { authFetch } from "../services/authFetch";

const CHANNEL_ACCOUNTS_URL = `${(process.env.REACT_APP_API_CONNECTION || "").replace(
  /\/api\/v1\/?$/,
  ""
)}/api/v1/conversations/channel-accounts`;

// Última respuesta buena, compartida entre vistas: cada ruta de la suite monta
// su propio layout y, sin esto, el rail arrancaba sin canales y los hacía
// aparecer de golpe al llegar la respuesta.
let lastKnownAccounts = null;

/** Cuentas de la última respuesta buena, o null si aún no hay ninguna. */
export function cachedChannelAccounts() {
  return lastKnownAccounts;
}

export async function fetchChannelAccounts() {
  const response = await authFetch(CHANNEL_ACCOUNTS_URL, {
    headers: {
      "x-app": "web",
      application: "web",
    },
  });
  if (!response.ok) {
    // El status permite distinguir "ruta aún no desplegada" (404/405) de un
    // error real.
    const error = new Error(`Error ${response.status}`);
    error.status = response.status;
    throw error;
  }
  const data = await response.json().catch(() => ({}));
  const accounts = data.channel_accounts ?? data.accounts ?? [];
  lastKnownAccounts = Array.isArray(accounts) ? accounts : [];
  return lastKnownAccounts;
}
